(function () {
  const initNewsletterForms = () => {
    document.querySelectorAll(".newsletter-form").forEach((form) => {
      const checkbox = form.querySelector(
        ".newsletter-form__checkbox input[type='checkbox'][required]"
      );

      if (!checkbox || form.dataset.newsletterValidationInit === "true") {
        return;
      }

      form.dataset.newsletterValidationInit = "true";

      const wrapper = form.closest(".newsletter__form");
      const errorEl =
        form.querySelector(".newsletter-form__checkbox-error") ||
        document.getElementById(
          checkbox.getAttribute("aria-describedby") || ""
        );
      const errorMessage =
        wrapper?.dataset.newsletterCheckboxError ||
        "Please accept the terms to subscribe.";

      const setCheckboxError = (show) => {
        if (show) {
          checkbox.setCustomValidity(errorMessage);
          checkbox.classList.add("checkbox--invalid");
          if (errorEl) {
            errorEl.textContent = errorMessage;
            errorEl.hidden = false;
          }
          return false;
        }

        checkbox.setCustomValidity("");
        checkbox.classList.remove("checkbox--invalid");
        if (errorEl) {
          errorEl.textContent = "";
          errorEl.hidden = true;
        }
        return true;
      };

      form.addEventListener("submit", (event) => {
        if (!checkbox.checked) {
          event.preventDefault();
          setCheckboxError(true);
          checkbox.reportValidity();
          checkbox.focus();
          return;
        }

        setCheckboxError(false);
      });

      checkbox.addEventListener("change", () => {
        if (checkbox.checked) {
          setCheckboxError(false);
        }
      });

      checkbox.addEventListener("invalid", (event) => {
        event.preventDefault();
        setCheckboxError(true);
      });
    });
  };

  document.addEventListener("DOMContentLoaded", initNewsletterForms);
  document.addEventListener("shopify:section:load", initNewsletterForms);
})();
